module.exports = __webpack_public_path__ + "static/img/8.68b2698.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/downloadImg/8.png
// module id = 789u
// module chunks = 1